<template>
    <div>
        <section class="section section-shaped section-lg my-0">
            <div class="shape shape-style-1 bg-gradient-default">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="container pt-lg-md container-title-content">
                <h3>Điều Khoản Dịch Vụ</h3>
            </div>
        </section>
        <section>
            <div class="row" style="margin-top: 30px;">
                <div class="container pt-lg-md">
                    <div class="row">
                        <div class="col-sm-4">
                            <ul id="navigation-help-list" class="navigation-help-list">
                                <li><router-link to="/dieu-khoan-dich-vu">Điều khoản dịch vụ</router-link></li>
                                <li><router-link to="/chinh-sach-bao-mat">Chính sách bảo mật</router-link></li>
                            </ul>
                        </div>
                        <div class="col-sm-8">
                            <div class="help-content-class">
                                <a name="dieu-khoan-dich-vu" id="dieu-khoan-dich-vu"></a>
                                <!-- <NapTien
                                        :items="trogiupjson"
                                /> -->
                                <DieuKhoanDichVu
                                        :items="dieukhoandichvu"
                                    />
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    </div>
</template>

<script>
import DieuKhoanDichVu from "vue-faq-accordion";
// const trogiupjson = "../../../assets/data/tro-giup.json";
import dieukhoandichvu from "../../../assets/data/dieu-khoan.json";
export default {
    name: "dieukhoandichvu",
        components: {
           DieuKhoanDichVu
    },
  data() {
    var data = dieukhoandichvu.map((item) => {
            return  {
                title: item.MessageTitle,
                value: item.MesssageContent,
            }
    }
    );
        return { dieukhoandichvu: data };
  },
  methods: {
      parseJson: () =>{
          return dieukhoandichvu = JSON.parse(dieukhoandichvu);
      }
  },
  beforeMount(){
  }
};
</script>
<style scoped>
    .help-content-class section div.faq-wrapper div.accordion {
        margin-top: 0;
    }
    .help-content-class .accordion[data-v-36e025b4]{
        margin-top: 0!important
    }
    .navigation-help-list{
        padding :0;
    }
</style>